import modules from '@/app/config/modules'
import assign from 'lodash/assign'
import Vue from 'vue'
import Vuex, { Store } from 'vuex'

Vue.use(Vuex)

const store: Store<any> = new Vuex.Store({
  state: {},

  mutations: {
    init(state) {
      const persisted = localStorage.getItem(process.env.VUE_APP_ID)
      if (persisted) {
        assign(state, JSON.parse(persisted))
      }
    },
  },

  actions: {},

  modules,
})

store.subscribe((_, state) => {
  localStorage.setItem(process.env.VUE_APP_ID, JSON.stringify(state))
})

export default store
